@if (viewMode === accountsViewMode.LIST) {
  <a class="account-list-row flex flex-col md:flex-row md:items-center gap-3 md:gap-6"
     [id]="'row-' + data.accountId"
     [routerLink]="accountSummaryUrl">

    <div class="account-list-row-info flex flex-col gap-1 min-w-0 md:flex-1">
      <div class="flex flex-row items-center gap-3 min-w-0">
        <span class="heading-sm-semibold color-content-default text-nowrap-ellipsis"
              [title]="data.accountTitles[0]"
              [id]="'account-title-' + data.accountId"
              data-testid="card-account-title-main">{{ data.accountTitles[0] }}</span>

        <span class="neutral-status-badge flex-none"
              [id]="(isIcxAccount(data.accountType) ? 'trans-acct-no-' : 'acct-id-') + data.accountId"
              data-testid="card-transaction-account-number"
              [title]="maskedAccountNumber">{{ maskedAccountNumber }}</span>
      </div>

      @if (otherAccountTitlesText) {
        <span class="body-sm-regular color-content-muted text-nowrap-ellipsis"
              [title]="otherAccountTitlesText"
              [id]="'other-account-titles-' + data.accountId"
              data-testid="card-account-title-two-three">{{ otherAccountTitlesText }}</span>
      }

      <div class="flex flex-row flex-wrap items-center gap-2 pt-1">
        <ng-container [ngTemplateOutlet]="badges"></ng-container>
      </div>
    </div>

    <div class="account-list-row-metrics flex flex-row items-start gap-4 md:gap-6">
      <div class="account-list-metric metric-maturity flex flex-col" [id]="'maturity-date-' + data.accountId">
        @if (data.accountType === accountType.CDARS) {
          <span class="body-md-regular color-content-subtle">{{ data.maturityDate | pinDate }}</span>
          <span class="body-sm-regular color-content-weak">MATURITY DATE</span>
        }
      </div>

      <div class="account-list-metric metric-rate flex flex-col" [id]="'interest-rate-' + data.accountId">
        <span class="body-md-regular color-content-subtle" data-testid="card-interest-rate">{{ data.interestRate | pinDecimal }}%</span>
        <span class="body-sm-regular color-content-weak">RATE</span>
      </div>

      <div class="account-list-metric metric-accrued flex flex-col" [id]="'accrued-interest-' + data.accountId">
        <span class="body-md-regular color-content-subtle"  data-testid="card-accrued-interest">{{ data.accruedInterest | pinCurrency }}</span>
        <span class="body-sm-regular color-content-weak">ACCRUED</span>
      </div>

      <div class="account-list-metric metric-balance flex flex-col" [id]="'principal-balance-' + data.accountId">
        <span class="body-md-semibold color-content-default" data-testid="card-principal-balance">{{ data.principalBalance | pinCurrency }}</span>
        <span class="body-sm-regular color-content-weak">
            @if (isIcxAccount(data.accountType)) {
              PRINCIPAL BALANCE
            } @else {
              ACCOUNT BALANCE
            }
        </span>
      </div>

      <span class="card-arrow-button self-center" aria-hidden="true" [id]="'go-to-summary-' + data.accountId">
              <mat-icon class="md-16 primary-color">chevron_right</mat-icon>
      </span>
    </div>
  </a>
} @else {
  <mat-card appearance="outlined" [id]="'card-' + data.accountId" class="account-list-card flex flex-col h-full"
            [class.pressed]="pressed"
            [routerLink]="accountSummaryUrl"
            (click)="onPress()"
            (keydown.enter)="onPress()"
            (keyup.enter)="redirectToAccountSummary()">

    <div id="OwnershipDetails" class="card-ownership flex flex-col gap-1 min-w-0">
      <div class="flex flex-row items-center gap-2 min-w-0">
        <div class="body-sm-regular color-content-muted text-nowrap-ellipsis"
             [id]="'acct-depositor-' + data.accountId" data-testid="card-depositor-main"
             [title]="accOwners[0].name">
          {{ accOwners[0].name }}
        </div>
        <pin-tooltip [showButton]=false
                     [showText]="!!getNumberOfOwners()"
                     [hoverText]=getNumberOfOwners()
                     [tooltipInfoList]=otherOwners
                     tooltipContainerClass="help-tooltip other-owners-tooltip"
                     textClass="text-decoration-underline body-sm-regular color-content-muted"
                     [id]="'acct-other-depositors-' + data.accountId"
                     data-testid="card-depositors-other-count"
                     [showTooltipOnHover]=true>
        </pin-tooltip>
      </div>

      <div class="flex flex-row items-center justify-between gap-2 min-w-0 pt-1">
        <div class="heading-sm-semibold color-content-default text-nowrap-ellipsis" [title]="data.accountTitles[0]"
             [id]="'account-title-' + data.accountId" data-testid="card-account-title-main">
          {{ data.accountTitles[0] }}
        </div>

        <span class="neutral-status-badge flex-none"
              [id]="(isIcxAccount(data.accountType) ? 'trans-acct-no-' : 'acct-id-') + data.accountId"
              data-testid="card-transaction-account-number"
              [title]="maskedAccountNumber">{{ maskedAccountNumber }}</span>
      </div>

      @if (otherAccountTitlesText) {
        <div class="body-sm-regular color-content-default text-nowrap-ellipsis" [title]="otherAccountTitlesText"
             [id]="'other-account-titles-' + data.accountId"
             data-testid="card-account-title-two-three">{{ otherAccountTitlesText }}
        </div>
      }
    </div>

    <div class="flex flex-col pt-4 pb-2 border-b-xs-subtle" [id]="'principal-balance-' + data.accountId">
      <div class="body-lg-semibold" data-testid="card-principal-balance">{{ data.principalBalance | pinCurrency }}</div>
      <div class="label-md-semibold color-content-weak">
        @if (isIcxAccount(data.accountType)) {
          PRINCIPAL BALANCE
        } @else {
          ACCOUNT BALANCE
        }
      </div>
    </div>

    <div class="flex flex-row py-3 border-b-xs-subtle">
      <div class="card-financial-item flex flex-col flex-1" [id]="'accrued-interest-' + data.accountId">
        <div class="body-md-regular color-content-subtle" data-testid="card-accrued-interest">{{ data.accruedInterest | pinCurrency }}</div>
        <div class="label-md-semibold color-content-weak">ACCRUED</div>
      </div>

      <div class="card-financial-item flex flex-col flex-1" [id]="'interest-rate-' + data.accountId">
        <div class="body-md-regular color-content-subtle" data-testid="card-interest-rate">{{ data.interestRate | pinDecimal }}%</div>
        <div class="label-md-semibold color-content-weak">RATE</div>
      </div>

      @if (data.accountType === accountType.CDARS) {
        <div class="card-financial-item flex flex-col flex-1" [id]="'maturity-date-' + data.accountId">
          <div class="body-md-regular color-content-subtle">{{ data.maturityDate | pinDate }}</div>
          <div class="label-md-semibold color-content-weak">MATURITY DATE</div>
        </div>
      }
    </div>

    <div class="flex flex-row items-center justify-between gap-4 mt-auto pt-4">
      <div class="flex flex-row flex-wrap items-center gap-4">
        <ng-container [ngTemplateOutlet]="badges"></ng-container>
      </div>

      <span class="card-arrow-button" aria-hidden="true" [id]="'go-to-summary-' + data.accountId">
              <mat-icon class="md-16 primary-color">chevron_right</mat-icon>
      </span>
    </div>
  </mat-card>
}

<ng-template #badges>
  @if (isIcxAccount(data.accountType)) {
    <span class="neutral-status-badge" [id]="'ics-badge-' + data.accountId">{{ productType.ICS }}</span>
    <span class="neutral-status-badge"
          [id]="data.accountType.toLowerCase() + '-' + data.accountId">{{ data.accountType }}</span>

    @if (data.cdbaIndicator === actStatus.YES) {
      <span class="neutral-status-badge" [id]="'act-badge-' + data.accountId">
          <mat-icon aria-hidden="true" class="md-14 primary-color mr-1 leading-none">volunteer_activism</mat-icon>
          <span>ACT PROGRAM</span>
      </span>
    }

    @if (data.accountStatus === accountStatus.INACTIVE) {
      <span class="danger-status-badge" [id]="'closed-badge-' + data.accountId">CLOSED</span>
    }
  } @else {
    <span class="neutral-status-badge" [id]="'cdars-badge-' + data.accountId">{{ productType.CDARS }}</span>
    @if (data.productTerm && !data.isMaturedAccount && data.accountStatus === accountStatus.ACTIVE) {
      <span class="neutral-status-badge" [id]="'product-badge-' + data.accountId">{{ data.productTerm }}</span>
    }
  }
</ng-template>
